import { usePathname } from 'next/navigation';

import { DEFAULT_LANGUAGE } from '@/helpers';

// English pages are served without the "/en" prefix: middleware rewrites "/about-us" to "/en/about-us".
// On statically generated pages usePathname() returns the internal "/en/about-us" on the server and
// "/about-us" in the browser, which breaks hydration of anything that depends on the path.
// This hook returns the path as the visitor sees it, the same on the server and in the browser.
export const useVisiblePathname = () => {
  const pathname = usePathname();

  if (pathname === `/${DEFAULT_LANGUAGE}`) {
    return '/';
  }
  if (pathname.startsWith(`/${DEFAULT_LANGUAGE}/`)) {
    return pathname.slice(DEFAULT_LANGUAGE.length + 1);
  }
  return pathname;
};
